module.exports = __webpack_public_path__ + "media/images/ajax_loader-bc5fb8194423bdb69d482d5bc5faee1a.gif";